import { Box, Grid, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const Header = styled(Box)({
  color: "#999999",
  paddingBottom: 5,
});

export const TalentGrid = styled(Grid)({
  backgroundColor: "#ffffff",
  borderRadius: 10,
  padding: 45,
  marginBottom: 30,
  border: "1px solid lightGrey",
});

export const TalentSectionContainer = styled(Box)({
  backgroundColor: "#ffffff",
  borderRadius: 10,
  padding: 20,
  marginBottom: 30, // TODO: is this needed
  border: "1px solid lightGrey",
  boxShadow:
    "0px 4px 6px -4px rgba(16, 24, 40, 0.1), 0px 10px 15px -3px rgba(16, 24, 40, 0.1)",
});

export const TalentSummaryCardContainer = styled(Box)({
  backgroundColor: "#ffffff",
  borderRadius: 12,
  padding: "16px 16px 8px 16px",
  marginBottom: "16px",
  width: "100%",
});

export const TalentSectionHeaderContainer = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const Header1 = styled(Typography)({
  fontWeight: 600,
  fontSize: "54px",
  marginBottom: "1rem",
});

export const Header2 = styled(Typography)({
  fontWeight: 500,
  fontSize: "34px",
  marginBottom: "1rem",
});

export const Header3 = styled(Typography)({
  fontWeight: 500,
  fontSize: "20px",
  marginBottom: "1rem",
});

export const PreviewSectionHeader = styled(Typography)({
  textTransform: "uppercase",
  fontWeight: 700,
  fontSize: "14px",
  paddingTop: "12px",
  paddingLeft: "12px",
});
